import { Pipe, PipeTransform } from '@angular/core';
import { isArray, isObject } from 'lodash';

@Pipe({
  name: 'enumToArray'
})
export class EnumToArrayPipe implements PipeTransform {

  transform(value: Record<string, any>): any {
    if (isArray(value) || !isObject(value))
      throw new TypeError('Invalid argument type. Must be enum.');
    // console.log('is array', isArray(value))
    const result = [];
    let keys = Object.keys(value);
    // console.log('keys',keys)
    keys = keys.slice(keys.length / 2);
    for (const key of keys) {
      result.push({ key, value: value[key] });
    }
    return result;
  }
}
